import { RequestMutationOptions } from '@approvalmax/data';
import { useMutate } from 'shared/data/api';

import { walletsApiPaths } from '../paths';
import { useInvalidateGetXeroBankFeeds } from '../useGetXeroBankFeeds/useGetXeroBankFeeds';
import { ConnectXeroBankFeed } from './useConnectXeroBankFeed.types';

export const useConnectXeroBankFeed = (mutationOptions?: RequestMutationOptions<ConnectXeroBankFeed>) => {
    const invalidateXeroBankFeeds = useInvalidateGetXeroBankFeeds();

    return useMutate(walletsApiPaths.connectXeroBankFeed, {
        mutationOptions: {
            ...mutationOptions,
            onSuccess: (...args) => {
                const [, variables] = args;

                invalidateXeroBankFeeds({
                    path: {
                        companyId: variables.params?.path?.companyId,
                    },
                });

                mutationOptions?.onSuccess?.(...args);
            },
        },
        apiVersion: 'v2',
    });
};
